import { NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthenticationService } from './authentication.service';
import { CanAccessInstructorSearchGuard } from './can-access-instructor-search.guard';
import { CanReadAdminGuard } from './can-read-admin.guard';
import { IsAdminGuard } from './is-admin.guard';
import { IsAuthenticatedGuard } from './is-authenticated.guard';
import { IsNotAuthenticatedGuard } from './is-not-authenticated.guard';

@NgModule({
  imports: [RouterModule],
  exports: [],
  declarations: [],
  providers: [
    AuthenticationService,
    IsAuthenticatedGuard,
    IsNotAuthenticatedGuard,
    IsAdminGuard,
    CanReadAdminGuard,
    CanAccessInstructorSearchGuard,
  ],
})
export class AuthenticationModule {
  constructor() {
    const parentModule = inject(AuthenticationModule, {
      optional: true,
      skipSelf: true,
    });

    if (parentModule) {
      throw new Error(
        'AuthenticationModule is already loaded. Import it in the AppModule only',
      );
    }
  }
}
